import VueAccessControl from './vue-access-control'
import VueDialog from './dialog'

export { VueAccessControl, VueDialog }
export default {
    VueAccessControl,
    VueDialog,
}
